import React, { Component } from 'react';
import { connect } from 'react-redux';
import {push} from 'react-router-redux';
import * as game from '../controllers';
import SelectInput from './components/selectInput';

const level = [
    {_id: "1", name: "1"},
    {_id: "2", name: "2"},
    {_id: "3", name: "3"},
    {_id: "4", name: "4"},
    {_id: "5", name: "5"},
    {_id: "6", name: "6"},
    {_id: "7", name: "7"},
    {_id: "8", name: "8"},
    {_id: "9", name: "9"},
    {_id: "10", name: "10"},
    {_id: "11", name: "11"},
    {_id: "12", name: "12"},
    {_id: "13", name: "13"}
];

class ForceUpdate extends Component {
    constructor (props) {
        super(props);
        this.state = {
            level: null,
            state: null
        };
    }
    onLevelSelectChange (value) {
        this.setState({level: value});
    }

    forceUpdate () {
        if (this.state.state !== null) {
            console.log('Entru aqui');
            game.user.forceUpdate({state: this.state.state});
        } else {
            game.user.forceUpdate({levelOrder: this.state.level});
        }
    }

    inputChanged (value) {
        this.setState({state: value});
    }
    render () {
        return (
            <div className='auth-background'>
                <div className='input-field-wrapper'>
                    <SelectInput options={level} value={this.state.level} onChange={(value) => this.onLevelSelectChange(value)} />
                </div>
                <div className='input-field-wrapper'>
                    <input type='number' placeholder='Estado apenas 0 ou 1' min='0' max='1' className='input-field' onChange={(e) => this.inputChanged(e.target.value)} />
                </div>
                <div className='auth-dashboard' onClick={() => this.forceUpdate()}>
                    <h4>Atualizar</h4>
                </div>
                <br />
                <div className='auth-dashboard' onClick={() => this.props.push('/')}>
                    <h4>Voltar</h4>
                </div>
            </div>
        );
    }
}

export default connect(null, {push})(ForceUpdate);



// WEBPACK FOOTER //
// ./src/views/forceUpdateView.js